import universalComponent from 'react-universal-component';
import { captureException } from '@sentry/browser';

export const defaultSettings = {
  loading: () => null,
  timeout: 30000, // 30 second timeout for code loading
  ignoreBabelRename: true,
  onError: (error) => {
    // eslint-disable-next-line no-console
    console.error(error);

    if (_DEBUG) {
      captureException(error);
    }
  },
};

export const universal = (importExpr, settings = {}) =>
  universalComponent(importExpr, { ...defaultSettings, ...settings });
